<template>
  <div class="row animated fadeIn">
    <div class="col-md-8 offset-md-2">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-align-justify"></i> <strong>Lista de Usuários</strong>
          <router-link :to="'users/new'" class="btn btn-secondary btn-sm pull-right" exact>
            <i class="fa fa-plus"></i> Novo Usuário
          </router-link>
        </div>
        <div class="card-block">
          <table class="table table-bordered">
            <thead class="thead-inverse">
              <tr>
                <th>Usuário</th>
                <th>Login</th>
                <th>Email</th>
                <th>Última atualização</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in orderedUsers">
                <td>
                  <router-link :to="'users/' + row.id">{{ row.firstName }} {{ row.lastName }}</router-link>
                </td>
                <td>{{ row.username }}</td>
                <td>{{ row.email }}</td>
                <td>{{ row.updatedAt | formatDate }}</td>
                <td class="actions">
                  <button type="button" class="btn btn-link" @click="showModal(row)"><i class="fa fa-trash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>

          <modal title="Modal title" class="modal" v-model="deleteModal" @ok="deleteModal = false" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
              <span class="modal-title"><strong>Excluir Usuário</strong></span>
            </div>
            <div slot="modal-body" class="modal-body">Deseja excluir o usuário
              <strong>{{ user.firstName + " " + user.lastName }}</strong>?
            </div>
            <div slot="modal-footer" class="modal-footer">
              <button type="button" class="btn btn-sm btn-default" @click="deleteModal = false">Cancelar</button>
              <button type="button" class="btn btn-sm btn-danger" @click.prevent="deleteTemplate">Confirmar</button>
            </div>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import modal from 'vue-strap/src/Modal'

export default {
  name: 'users',
  components: {
    modal
  },
  data () {
    return {
      deleteModal: false,
      users: [],
      user: {}
    }
  },
  computed: {
    orderedUsers: function () {
      return this.users.sort((a, b) => {
        return Date.parse(b.updatedAt) - Date.parse(a.updatedAt)
      })
    }
  },
  created () {
    this.loadUsers()
  },
  methods: {
    deleteTemplate () {
      this.deleteModal = false
      axios.delete(process.env.MYSTIQUE_MANAGER_API_URL + 'users/' + this.user.id).then(response => {
        this.showSuccess('Usuário excluído com sucesso!')
        this.loadUsers()
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao excluir o usuário.')
      })
    },
    loadUsers () {
      axios.get(process.env.MYSTIQUE_MANAGER_API_URL + 'users').then(response => {
        this.users = response.data
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao carregar os usuários.')
      })
    },
    showModal (user) {
      this.user = user
      this.deleteModal = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// Index.vue?2c7cc703